import { getFunctionUrl } from "./functionEndpoints.js";

export const readSheetTitles = async (spreadsheetAccessData) => {
  const url = getFunctionUrl("cors-proxy");
  const requestBody = JSON.stringify(
    spreadsheetAccessData
  );
  const req = await fetch(url, {
    body: requestBody, 
    headers: {"Content-Type": "application/json"}, 
    method: 'POST'
  });
  const metadata = await req.json();
  const hasValidMetadata =
    metadata &&
    typeof metadata.properties?.title === 'string' &&
    Array.isArray(metadata.sheets);

  if (req.ok && hasValidMetadata) {
    return metadata;
  }

  console.error('Could not read sheet titles', {
    status: req.status,
    metadata
  });
  return null;
}
export default readSheetTitles;
